import { useState, useEffect } from "react"
import axios from "axios";
import { useNavigate } from "react-router-dom";
import ResponsiveAppBar from "../ResponsiveAppBar"
import ResponsiveFooter from "../ResponsiveFooter";

import * as React from 'react';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import { Grid } from '@mui/material';
import RegionCard from "../RegionCard.js";

import * as constants from "../constants.js"

const LandingPage = () => {
  const [regionsData, setRegionsData] = useState([]);
  const navigate = useNavigate();

    useEffect(() => {
        (async () => {
          try {
              const resp = await axios.create({
                  withCredentials: true,
              }).get("//" + constants.BASE_URL + "/getMyRegionIds");
              setRegionsData(resp.data);
          } catch (error) {
              if (error.response && error.response.status === 401) {
                  navigate('/login');
              } else {
                  console.error('Error fetching data:', error);
              }
          }
        })();
      }, []);

      const handleAddButtonClick = () => {
        navigate('/add-region');
      };
     
    return ( 
        <div className="home">
            <ResponsiveAppBar />
            <div className="body-content">
              <br></br>
              <h2>Meine Regionen</h2>
              <br></br>
              <Grid container spacing={3}>
                {regionsData.map((regionId, index) => (
                  <Grid item key={index} xs={12} sm={12} md={12} lg={12}>
                    <RegionCard regionId={regionId} />
                  </Grid>
                ))}
              </Grid>
              <br></br>
            <div style={{display: "flex", justifyContent: "center"}}>
            <Button onClick={handleAddButtonClick}>
              <AddIcon />
            </Button>
            </div>
          </div>
          <ResponsiveFooter />
        </div>
     );
}
 
export default LandingPage;